module.exports = __webpack_public_path__ + "img/ic_20_copy.4b65ab80.svg";